var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container", attrs: { loading: _vm.saveLoad } },
    [
      _c("div", { staticClass: "formLine" }, [_vm._v("活动集客信息")]),
      _c(
        "div",
        { staticClass: "budgetBox" },
        [
          _c(
            "el-form",
            {
              ref: "actCustomer",
              staticClass: "UniformCss",
              attrs: {
                inline: true,
                model: _vm.actCustomer,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { staticClass: "flex-row" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动编码", prop: "actCode" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.viewDisabled,
                              clearable: "",
                            },
                            model: {
                              value: _vm.actCustomer.actCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.actCustomer, "actCode", $$v)
                              },
                              expression: "actCustomer.actCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户姓名", prop: "customerName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.viewDisabled,
                              clearable: "",
                            },
                            model: {
                              value: _vm.actCustomer.customerName,
                              callback: function ($$v) {
                                _vm.$set(_vm.actCustomer, "customerName", $$v)
                              },
                              expression: "actCustomer.customerName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号", prop: "mobile" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "number",
                              disabled: _vm.viewDisabled,
                              clearable: "",
                            },
                            model: {
                              value: _vm.actCustomer.mobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.actCustomer, "mobile", $$v)
                              },
                              expression: "actCustomer.mobile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "品系", prop: "seriesCode" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: _vm.viewDisabled },
                              on: { change: _vm.selectChange },
                              model: {
                                value: _vm.actCustomer.seriesCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.actCustomer, "seriesCode", $$v)
                                },
                                expression: "actCustomer.seriesCode",
                              },
                            },
                            _vm._l(_vm.seriesList, function (item) {
                              return _c("el-option", {
                                key: item.strainsCode,
                                attrs: {
                                  label: item.strains,
                                  value: item.strainsCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "dealerName" } },
                        [
                          _c(
                            "label",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("span", { staticClass: "el-item-label" }, [
                                _vm._v("所属经销商"),
                              ]),
                            ]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "195px" },
                            attrs: { disabled: _vm.viewDisabled },
                            on: { focus: _vm.chooseDealer },
                            model: {
                              value: _vm.actCustomer.dealerName,
                              callback: function ($$v) {
                                _vm.$set(_vm.actCustomer, "dealerName", $$v)
                              },
                              expression: "actCustomer.dealerName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btn-container" },
            [
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.returnFun()
                    },
                  },
                },
                [_vm._v("返回")]
              ),
              !_vm.viewDisabled
                ? _c(
                    "vxe-button",
                    {
                      attrs: { status: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.onSubmit()
                        },
                      },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择经销商",
            visible: _vm.dealerDialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dealerDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("el-input", {
                style: { width: "80%" },
                attrs: { placeholder: "输入经销商名称", clearable: "" },
                on: { change: _vm.findDealers },
                model: {
                  value: _vm.dealerName,
                  callback: function ($$v) {
                    _vm.dealerName = $$v
                  },
                  expression: "dealerName",
                },
              }),
              _c(
                "vxe-button",
                {
                  staticClass: "filter-search-item",
                  staticStyle: { float: "right" },
                  attrs: { status: "primary", icon: "el-icon-search" },
                  on: { click: _vm.findDealers },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              ref: "Xdealer",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.dealerLoading,
                "max-height": "370",
                align: "center",
                "scroll-y": { enabled: false },
                data: _vm.dealerLists,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
                "radio-config": {
                  strict: false,
                  labelField: "seq",
                  trigger: "row",
                  isCurrent: true,
                  isHover: true,
                },
              },
            },
            [
              _c("vxe-column", { attrs: { type: "radio", width: "60" } }),
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "id", title: "经销商ID", width: "110" },
              }),
              _c("vxe-column", {
                attrs: { field: "name", title: "经销商名称", width: "220" },
              }),
              _c("vxe-column", { attrs: { field: "address", title: "地址" } }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              loading: _vm.dealerLoading,
              "current-page": _vm.addTablePage.currentPage,
              "page-size": _vm.addTablePage.pageSize,
              total: _vm.addTablePage.totalResult,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.handleAddPageChange },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dealerDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: { click: _vm.handleChooseDealer },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }